export default __webpack_public_path__ + "static/media/fMaltoBuza42.43b1a69c.png";